const getters = {
  userInfo: (state) => state.user.userInfo,
  lockPasswd: (state) => state.common.lockPasswd,
  access_token: (state) => state.user.access_token,
  refresh_token: (state) => state.user.refresh_token,
  tenantId: (state) => state.user.tenantId, // 租户id
  tenantName: (state) => state.user.tenantName, // 租户名称
  userId: (state) => state.user.userId, // 用户id
  isAdminTenant: (state) => state.user.isAdminTenant, // 是否是管理员租户
};
export default getters;
